import React, { Component } from "react";

import {
  Col,
  Container,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import {
  addInvoice,
  addCustomInvoice,
  getInvoiceChoice,
  postInvoiceByOffer,
  postInvoiceBySalary,
} from "../../../../store/invoices/actions";
import { getClientById, setClient } from "../../../../store/clients/actions";
import { getMetaCountries } from "../../../../store/meta/actions";
import { getOffers, getOffersByContract, setOffersByContract } from "../../../../store/offers/actions";
import classnames from "classnames";
import InvoiceType from "../../../../components/forms/InvoicesForm/InvoiceType";
import { getCurrentDay } from "../../../../helpers/utils";
import {
  getContractorsList,
  addContractor,
  updateContractorProfile,
} from "../../../../store/contractors/actions";
import {
  getLegalEntityList,
  addLegalEntity,
  updateLegalEntityProfile,
} from "../../../../store/legal-entity/actions";
import { getPositionsList } from "../../../../store/positions/actions";
import { getUsersToList } from "../../../../store/user/user-list/actions";
import { INITIAL_DATA_PARAMS } from "../../../../constants/store";
import EditCustomInvoiceModal from "../components/EditCustomInvoiceModal";
import { getErrorMessage, showErrorMessage } from "../../../../helpers/utils";
import ModifiedMetaTags from "../../../../components/ModifiedMetaTags";
import { getInvoiceTemplateList } from '../../../../store/invoice_templates/actions';
import {
  getBonuses,
} from "../../../../store/salary-bonuses/actions";
import {
  getBankDetailsForUser,
  setBankDetailsForUser,
} from "../../../../store/bank-details/actions";

class AddInvoices extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "salary",
      viewEditInvoiceModal: {
        status: false,
        type: "",
        data: {},
        selectedClient: undefined,
        selectedBank: undefined,
      },
      isFormSubmit: false,
    };
  }

  componentDidMount() {
    this.props.getMetaCountries();
    this.props.getInvoiceChoice();
    this.props.getInvoiceTemplateList({
      ...this.props.invoice_templates,
    })
    this.props.getPositionsList({
      ...this.props.positions,
      sizePerPage: 0,
    });
    this.props.getOffers({
      ...this.props.offers,
      sizePerPage: 0,
      is_main: true,
    });
    this.props.getContractorsList({
      ...this.props.contractors,
      sizePerPage: 0,
    });
    this.props.getLegalEntityList({
      ...INITIAL_DATA_PARAMS,
      sizePerPage: 0,
    });
    this.props.getBonuses({
      sizePerPage: 0,
    });
  }

  componentDidUpdate(prevProps, props) { }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
        isFormSubmit: false,
      });
    }
  }

  onSubmitCustomForm = (e, errors, params) => {
    this.setState({ isFormSubmit: true });

    if (errors?.length === 0) {
      let data = {
        ...params,
      };

      for (const key in data) {
        if (data[key] === "") {
          delete data[key];
        } else if (Array.isArray(data[key])) {
          data[key] = data[key].map(i => i.value);
        } else if (data[key]?.value) {
          data[key] = data[key].value;
        } else if (!!Number(data[key])) {
          data[key] = +data[key];
        }
      }

      let items = [];

      for (const key in data) {
        const split = key.split("_");
        if (split.length === 2) {
          const k = split[0];
          let suffix = items.find(i => i.id === split[1])?.id;
          if (suffix !== undefined) {
            let idx = items.findIndex(i => i.id === suffix);
            items[idx][k] = params[key];
          } else {
            items.push({
              id: split[1],
              [k]: params[key]
            });
          }
        }
      }

      //this.state.selectedBank !== undefined
      // 
      if (
        this.state.selectedClient !== undefined
      ) {
        let selectedClient = this.props.contractors.results.find(
          item => item.id === this.state.selectedClient
        );

        // let selectedBank = this.props.legal_entity.results.find(
        //   item => item.id === this.state.selectedBank
        // );

        const clientData = [
          "counterparty_name",
          // "customer_email",
          "customer_country",
          "customer_city",
          "customer_street",
          "postal_address",
        ];
        // const bankData = [
        //   "counterparty_name",
        //   "bank_street",
        //   "bank_country",
        //   "postal_address",
        //   "bank_iban",
        //   "bank_city",
        //   "swift",
        // ];

        data["items"] = [];
        data["contractor"] = selectedClient.id;

        // bankData.map(item => {
        //   data[item] = selectedBank[item] || "";
        // });

        clientData.map(item => {
          data[item] = selectedClient[item] || "";
        });

        data["date_issue"] = getCurrentDay();
        data["date_tax_point"] = getCurrentDay();

        items.map(i => {
          data.items.push({
            title: i['service-name'],
            // quantity: i.quantity || '0',
            unit_price: i.sum || '0',
            ...(i['date-from'] && { date_from: i['date-from'] }),
            ...(i['date-to'] && { date_to: i['date-to'] })
          });
        });

        let dataForAdd = {
          contractor_id: selectedClient.id,
          language: data.language,
          payment_method: data.payment_method,
          date_due: data.date_due,
          items: data.items.filter((f) => f.title !== undefined),
          ...(data?.currency && { currency: data?.currency }),
          ...(data?.currency_value && { currency_value: data?.currency_value })
        }
        this.props.addCustomInvoice(dataForAdd, this.props.history);
      } else {
        const { selectedClient, selectedBank } = this.state;
        showErrorMessage(
          getErrorMessage(
            `Field ${selectedClient === undefined ? "client" : ""} must be selected`
          )
        );
      }
    }
  };

  onSubmitOfferForm = (e, errors, params) => {
    this.setState({ isFormSubmit: true });

    if (errors?.length === 0) {
      let data = {
        ...params,
      };

      for (const key in data) {
        if (data[key] === "") {
          delete data[key];
        } else if (Array.isArray(data[key])) {
          data[key] = data[key].map(i => i.value);
        } else if (data[key]?.value) {
          data[key] = data[key].value;
        } else if (!!Number(data[key])) {
          data[key] = +data[key];
        }
      }

      if (data.offer_ids?.length == 0) {
        let all = this.props.offers?.results
          .filter(i => i.contract === data?.client)
          .map(item => item.id)
        data.offer_ids = all;
      }

      data['contractor_id'] = data?.client;

      delete data.client

      // console.log(data)
      this.props.postInvoiceByOffer(data, this.props.history);
    }
  };

  onSubmitSalaryForm = (e, errors, params) => {
    this.setState({ isFormSubmit: true });

    if (errors?.length === 0) {
      let data = {
        ...params,
      };
      for (const key in data) {
        if (data[key] === "") {
          delete data[key];
        } else if (Array.isArray(data[key])) {
          data[key] = data[key].map(i => i.value);
        } else if (data[key]?.value) {
          data[key] = data[key].value;
        } else if (!!Number(data[key])) {
          data[key] = +data[key];
        }
      }

      delete data['calendar'];
      this.props.postInvoiceBySalary(data, this.props.history);
    }
  };

  toggleViewEditInvoiceModal = (type, data) => {
    this.setState(prevState => ({
      viewEditInvoiceModal: {
        status: !prevState.viewEditInvoiceModal.status,
        type,
        data,
      },
    }));
  };

  toggleModalUpdate = (params, data) => {
    if (params.type === "update") {
      switch (params.who) {
        case "client":
          this.props.updateContractorProfile(data.id, data.params, {
            sizePerPage: 1000,
            page: 1,
          });
          break;
        case "bank":
          this.props.updateLegalEntityProfile(data.id, data.params, {
            sizePerPage: 1000,
            page: 1,
          });
          break;
        default:
          return "";
      }
    } else if (params.type === "create") {
      switch (params.who) {
        case "client":
          this.props.addContractor(data.params, this.props.contractors);
          break;
        case "bank":
          this.props.addLegalEntity(data.params, this.props.legal_entity);
          break;
        default:
          return "";
      }
    }
  };

  onGetClientById = id => {
    this.props.getClientById(id);
  };

  onChangeSelected = (type, id) => {
    if (type === "client") {
      this.setState({
        selectedClient: id,
      });
    } else if (type === "bank") {
      this.setState({
        selectedBank: id,
      });
    }
  };

  onGetUsersByPosition = position => {
    this.props.getUsersToList({
      ...this.props.users,
      sizePerPage: 1000,
      position
    });
  };

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Add Invoice | Mobihunter" />

          <Container fluid>
            <Breadcrumbs
              title="Invoices"
              breadcrumbItem="Add Invoices"
              link="/invoices"
            />

            <EditCustomInvoiceModal
              toggle={this.toggleViewEditInvoiceModal}
              toggleModalUpdate={this.toggleModalUpdate}
              isOpen={this.state.viewEditInvoiceModal.status}
              data={this.state.viewEditInvoiceModal.data}
              type={this.state.viewEditInvoiceModal.type}
              bankLoader={this.props.legal_entity_loader}
              clientLoader={this.props.contractor_loader}
            />

            <div className="checkout-tabs">
              <Row className="justify-content-center">
                <Col lg="2" sm="3">
                  <Nav className="flex-column" pills>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === "salary",
                        })}
                        onClick={() => {
                          this.toggleTab("salary");
                        }}
                      >
                        <i className="mdi mdi-cash-check d-block check-nav-icon mt-4 mb-2" />
                        <p className="font-weight-bold mb-4">Salary</p>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === "offer",
                        })}
                        onClick={() => {
                          this.toggleTab("offer");
                        }}
                      >
                        <i className="mdi mdi-autorenew d-block check-nav-icon mt-4 mb-2" />
                        <p className="font-weight-bold mb-4">Client</p>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: this.state.activeTab === "custom",
                        })}
                        onClick={() => {
                          this.toggleTab("custom");
                        }}
                      >
                        <i className="mdi mdi-lead-pencil d-block check-nav-icon mt-4 mb-2" />
                        <p className="font-weight-bold mb-4">Custom</p>
                      </NavLink>
                    </NavItem>
                  </Nav>
                </Col>
                <Col lg="7" sm="9">
                  <TabContent activeTab={this.state.activeTab}>
                    <TabPane
                      tabId={this.state.activeTab}
                      className="fade-in-custom-animate"
                    >
                      <InvoiceType
                        type={this.state.activeTab}
                        clients={this.props.clients}
                        choices={this.props.choices}
                        offers={this.props.offers}
                        offers_loading={this.props.offers_loading}
                        client={this.props.client}
                        countries={this.props.countries}
                        onGetClientById={this.onGetClientById}
                        setClient={this.props.setClient}
                        isFormSubmit={this.state.isFormSubmit}
                        contractors={this.props.contractors}
                        contractor_loader={this.props.contractor_loader}
                        legal_entity={this.props.legal_entity}
                        legal_entity_loader={this.props.legal_entity_loader}
                        toggleViewEditInvoiceModal={
                          this.toggleViewEditInvoiceModal
                        }
                        onChangeSelected={this.onChangeSelected}
                        positions={this.props.positions.results}
                        positions_loading={this.props.positions_loading}
                        users={this.props.users.results}
                        users_loading={this.props.users_loading}
                        onGetUsersByPosition={this.onGetUsersByPosition}
                        loading_invoice={this.props.loading_invoice}
                        onSubmitSalaryForm={this.onSubmitSalaryForm}
                        onSubmitOfferForm={this.onSubmitOfferForm}
                        onSubmitCustomForm={this.onSubmitCustomForm}
                        bonuses={this.props.bonuses}
                        bonuses_loader={this.props.bonuses_loader}
                        getOffersByContract={this.props.getOffersByContract}
                        contractOffers={this.props.contractOffers}
                        contractOffersLoader={this.props.contractOffersLoader}
                        invoice_templates={this.props.invoice_templates}
                        invoice_templates_loading={this.props.invoice_templates_loading}
                        getBankDetailsForUser={this.props.getBankDetailsForUser}
                        bankDetails={this.props.bankDetails}
                        loading_details={this.props.loading_details}
                      />
                    </TabPane>
                  </TabContent>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AddInvoices.propTypes = {
  countries: PropTypes.arrayOf(PropTypes.object).isRequired,
  clients: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  offers: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  contractors: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  legal_entity: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  users: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  choices: PropTypes.object.isRequired,
  positions: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  loading_invoice: PropTypes.bool.isRequired,
  positions_loading: PropTypes.bool.isRequired,
  users_loading: PropTypes.bool.isRequired,
  legal_entity_loader: PropTypes.bool.isRequired,
  contractor_loader: PropTypes.bool.isRequired,
  offers_loading: PropTypes.bool.isRequired,
  getContractorsList: PropTypes.func,
  addInvoice: PropTypes.func.isRequired,
  getInvoiceChoice: PropTypes.func.isRequired,
  getClientById: PropTypes.func.isRequired,
  getOffers: PropTypes.func.isRequired,
  getMetaCountries: PropTypes.func.isRequired,
  getLegalEntityList: PropTypes.func.isRequired,
  setClient: PropTypes.func.isRequired,
  addContractor: PropTypes.func.isRequired,
  addLegalEntity: PropTypes.func.isRequired,
  updateLegalEntityProfile: PropTypes.func.isRequired,
  updateContractorProfile: PropTypes.func.isRequired,
  postInvoiceByOffer: PropTypes.func.isRequired,
  postInvoiceBySalary: PropTypes.func.isRequired,
  getPositionsList: PropTypes.func.isRequired,
  getUsersToList: PropTypes.func.isRequired,
  getBonuses: PropTypes.func.isRequired,
  bonuses: PropTypes.object.isRequired,
  bonuses_loader: PropTypes.bool.isRequired,
  getOffersByContract: PropTypes.func.isRequired,
  contractOffers: PropTypes.arrayOf(PropTypes.object),
  contractOffersLoader: PropTypes.boolean,
  addCustomInvoice: PropTypes.func.isRequired,
  invoice_templates: PropTypes.object,
  invoice_templates_loading: PropTypes.bool.isRequired,
  getInvoiceTemplateList: PropTypes.func.isRequired,
  getBankDetailsForUser: PropTypes.func.isRequired,
  setBankDetailsForUser: PropTypes.func.isRequired,
  bankDetails: PropTypes.object.isRequired,
  loading_details: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  countries: state.Meta.countries,
  offers: state.Offers.offers,
  offers_loading: state.Offers.loading,
  positions: state.Positions.data,
  positions_loading: state.Positions.loading,
  contractors: state.ContractorList.data,
  legal_entity: state.LegalEntityList.data,
  legal_entity_loader: state.LegalEntityList.loading,
  contractor_loader: state.ContractorList.loading,
  clients: state.Clients.data,
  client: state.Clients.client,
  choices: state.InvoiceList.choices,
  users: state.UsersList.data,
  users_loading: state.UsersList.loading,
  loading_invoice: state.InvoiceList.loading,
  permissions: state.User.permissions,
  bonuses: state.SalaryBonuses.data,
  bonuses_loader: state.SalaryBonuses.loading,
  contractOffers: state.Offers.contractOffers,
  contractOffersLoader: state.Offers.contractOffersLoader,
  invoice_templates: state.InvoiceTemplates.data,
  invoice_templates_loading: state.InvoiceTemplates.loading,
  bankDetails: state.BankDetails.user_data,
  loading_details: state.BankDetails.loading,
});

export default connect(mapStateToProps, {
  getBonuses,
  addInvoice,
  getInvoiceChoice,
  getOffers,
  getClientById,
  getMetaCountries,
  setClient,
  getContractorsList,
  getLegalEntityList,
  addContractor,
  updateContractorProfile,
  addLegalEntity,
  updateLegalEntityProfile,
  getPositionsList,
  getUsersToList,
  postInvoiceByOffer,
  postInvoiceBySalary,
  getOffersByContract,
  addCustomInvoice,
  getInvoiceTemplateList,
  getBankDetailsForUser,
  setBankDetailsForUser
})(AddInvoices);
